import ContactForm from '@components/ContactForm/ContactForm';
import styles from './Contact.module.css';

export default function Contact() {
  return (
    <>
      {/* ── 1. Page Header ──────────────────────────── */}
      <section className={styles.hero}>
        <div className={styles.container}>
          <h1 className={styles.heroTitle}>Nous contacter</h1>
          <p className={styles.heroSubtitle}>
            Nous sommes à votre écoute pour répondre à vos questions.
          </p>
        </div>
      </section>

      {/* ── 2. Contact Form Section ──────────────── */}
      <section className={styles.section}>
        <div className={styles.container}>
          <div className={styles.formWrapper}>
            <div className={styles.formContent}>
              <h2 className={styles.sectionHeading}>Envoyez-nous un message</h2>
              <p className={styles.sectionSubheading}>
                Pour toute question ou collaboration, n&rsquo;hésitez pas à nous
                contacter. Nous répondrons dans les plus brefs délais.
              </p>
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
